import React, {useState} from 'react';
import {Linking, Text, TouchableOpacity, View} from 'react-native';
import {useSelector} from 'react-redux';
import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';
import {BodyText} from 'src/Modules/CommonView';

import GetDirectionsCard from 'src/Modules/GetDirectionsCard.js';
import HuntListCard from 'src/Modules//HuntListCard.js';
import CarouselView from 'src/Modules/CommonView/CarouselView';
import ContinueHuntCard from 'src/Modules/CommonView/ContinueHuntCard';
import {navigationRef} from 'src/Nav/navigationHelpers';
import {parseHTML} from '../Utils/dataHelper';
import DelayedLoad from '../Nav/DelayedLoad';
import {cloudFlareOptimizeImage} from '../Utils/helpers';

// teambuilding dude thumbs up
const teambuilding_dude = {
  uri: cloudFlareOptimizeImage(
    'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648578460_medium.jpg',
  ),
};
// bachelorette party confetti
const bachelorettes = {
  uri: cloudFlareOptimizeImage(
    'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648578550_large.jpg',
  ),
};

// kid with camera, taking selfie with family
const birthday = {
  uri: cloudFlareOptimizeImage(
    'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648578676_medium.jpg',
  ),
};

const redeemImage = {
  uri: cloudFlareOptimizeImage(
    'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648577343_medium.jpg',
  ),
};

const ScavengerHuntInfoAbout = ({handleStartPress}) => {
  const {width} = useWindowDimensionsSafe();
  const [showMore, setShowMore] = useState(0);

  const currentHunt = useSelector((state) => state.hunts.currentHunt);
  const barHunt = currentHunt?.hunt_type?.includes('bar');
  const {
    lat,
    long,
    long_description,
    lr_long_description,
    is_free,
    description,
    starting_location,
    hunt_type,
  } = currentHunt || {};
  console.log({currentHunt});
  const longDescription =
    lr_long_description || long_description || description;

  var parsedDescription = parseHTML(longDescription || '');

  // Alert.alert(is_free);
  if (is_free && is_free != '0') {
    parsedDescription = 'This Hunt is free to play! ' + parsedDescription;
  }
  const trimmedShortDescription = parsedDescription.substring(0, 200);
  const shortDescription =
    trimmedShortDescription.substr(
      0,
      Math?.min(
        trimmedShortDescription?.length || 0,
        trimmedShortDescription?.lastIndexOf(' ') || 0,
      ),
    ) + '...';

  var activity_description = 'Scavenger Hunt';
  if (barHunt) {
    activity_description = 'Bar Hunt and Crawl';
  } else if (hunt_type == 'artWalk') {
    activity_description = 'Art Walk Scavenger Hunt';
  }

  return (
    <View style={{backgroundColor: global?.color?.white1}}>
      <View style={{backgroundColor: 'black', width, height: 140, top: -5}}>
        <HuntListCard
          hideNavigate
          hunt={currentHunt}
          disableTouch={true}
          // hideFlag={hideFlag}
          width={width}
          extraMargin={0}
        />
      </View>
      <DelayedLoad delay={250}>
        <View
          style={{
            justifyContent: 'flex-start',
            top: -5,
            // marginHorizontal: 10,
            padding: 5,
            backgroundColor: 'white',
            elevation: 8,
            shadowColor: 'black',
            shadowOffset: {width: 0, height: 0},
            shadowRadius: 6,
            shadowOpacity: 0.35,
            paddingBottom: 30,
            position: 'relative',
          }}>
          {/* on modal after clicking activity on home page */}
          <BodyText
            text={`About This ${activity_description}`}
            textStyle={{
              fontSize: 16,
              lineHeight: 24,
              color: global?.color?.gray3,
              fontWeight: '600',
              textAlign: 'center',
            }}
          />
          <BodyText
            text={!!showMore ? parsedDescription : shortDescription}
            textStyle={{fontSize: 14, lineHeight: 18}}
          />

          {!!barHunt && !!showMore && (
            <View>
              <BodyText
                text={`What is a Bar Hunt`}
                textStyle={{
                  fontSize: 16,
                  lineHeight: 24,
                  color: global?.color?.gray3,
                  fontWeight: '600',
                  textAlign: 'center',
                  marginTop: 30,
                }}
              />
              <BodyText
                text={
                  'A Bar Hunt is a gamified bar crawl that you can play any night with your friends. You can also play with others on specified nights. You and your friends will compete to finish challenges in order to fight for the top spot.'
                }
                textStyle={{fontSize: 14, lineHeight: 18}}
              />
            </View>
          )}
          <TouchableOpacity
            onPress={() => setShowMore(!showMore)}
            style={{position: 'absolute', bottom: 5, right: 5}}>
            <Text
              style={{
                fontFamily: global?.font.circular,
                color: global?.color?.gray2,
                fontSize: 12,
              }}>
              {!!showMore ? 'Show Less' : 'Read More'}
            </Text>
          </TouchableOpacity>
        </View>

        <ContinueHuntCard
          warning
          containerStyle={{
            width: width,
            height: 80,
            marginLeft: 0,
            marginTop: -5,
          }}
        />

        {hunt_type !== 'inHome' && (
          <GetDirectionsCard
            starting_location={starting_location}
            lat={lat}
            long={long}
            hunt={currentHunt}
          />
        )}
        <DelayedLoad>
          <View style={{width: '100%', minHeight: 300}}>
            <BodyText
              text={'Create An Event:'}
              textStyle={{
                marginTop: 20,
                paddingTop: 5,
                fontWeight: '700',
              }}
            />

            <CarouselView
              dataSource={[
                {
                  name: 'Create New Group',
                  description: 'Create a new group for your friends to join!',
                  handlePress: () => {
                    handleStartPress();
                  },
                  image: redeemImage,
                },
                {
                  name: 'Corporate Team Building',
                  description:
                    'Be an office pro and book a scavenger hunt for your team! We will work with you to modify this hunt to create custom stops and challenges for everyone to enjoy.',
                  handlePress: () => {
                    return Linking?.openURL(
                      'https://www.letsroam.com/team_building_activities?utm_source=lr_app&utm_medium=events_redirect',
                    );
                  },
                  image: teambuilding_dude,
                },
                {
                  name: 'Bachelorette Party',
                  description:
                    'Put on the ultimate Bachelorette party with a custom built Bachelorette scavenger hunt!',
                  handlePress: () => {
                    return Linking?.openURL(
                      'https://www.letsroam.com/bachelorette_scavenger_hunt?utm_source=lr_app&utm_medium=events_redirect',
                    );
                  },
                  image: bachelorettes,
                },
                {
                  name: 'Birthday Party',
                  description:
                    'Put on the best Birthday party with a custom Birthday scavenger hunt!',
                  handlePress: () => {
                    return Linking?.openURL(
                      'https://www.letsroam.com/activities/birthday_scavenger_hunt?utm_source=lr_app&utm_medium=events_redirect',
                    );
                  },
                  image: birthday,
                },
                {
                  name: 'Join Friends Group',
                  description: 'Join a friends group using their custom code!',
                  handlePress: () => {
                    navigationRef.navigate('JoinHuntModal');
                  },
                  image: redeemImage,
                },
                {
                  name: 'Corporate Team Building',
                  description:
                    'Be an office pro and book a scavenger hunt for your team! We will work with you to modify this hunt to create custom stops and challenges for everyone to enjoy.',
                  handlePress: () => {
                    return Linking?.openURL(
                      'https://www.letsroam.com/team_building_activities?utm_source=lr_app&utm_medium=events_redirect',
                    );
                  },
                  image: teambuilding_dude,
                },
              ]}
              data={[0, 1, 2, 3, 4]}
              type={'custom_card'}
            />
          </View>
        </DelayedLoad>
      </DelayedLoad>
    </View>
  );
};

export default ScavengerHuntInfoAbout;
